import account from "./account.ts";
import accountUpdateCard from "./accountUpdateCard.ts";
import achievements from "./achievements.ts";
import advancedPlayerSearch from "./advancedPlayerSearch.ts";
import allStar from "./allStar.ts";
import allStarDunk from "./allStarDunk.ts";
import allStarHistory from "./allStarHistory.ts";
import allStarTeams from "./allStarTeams.ts";
import allStarThree from "./allStarThree.ts";
import autoExpand from "./autoExpand.ts";
import autoRelocate from "./autoRelocate.ts";
import awardRaces from "./awardRaces.ts";
import awardsRecords from "./awardsRecords.ts";
import colleges from "./colleges.ts";
import comparePlayers from "./comparePlayers.ts";
import countries from "./countries.ts";
import customizePlayer from "./customizePlayer.ts";
import dailySchedule from "./dailySchedule.ts";
import dangerZone from "./dangerZone.ts";
import dashboard from "./dashboard.ts";
import defaultNewLeagueSettings from "./defaultNewLeagueSettings.ts";
import depth from "./depth.ts";
import draft from "./draft.ts";
import draftHistory from "./draftHistory.ts";
import draftLottery from "./draftLottery.ts";
import draftPicks from "./draftPicks.ts";
import draftScouting from "./draftScouting.ts";
import draftTeamHistory from "./draftTeamHistory.ts";
import editAwards from "./editAwards.ts";
import exhibition from "./exhibition.ts";
import exhibitionGame from "./exhibitionGame.ts";
import expansionDraft from "./expansionDraft.ts";
import exportLeague from "./exportLeague.ts";
import exportPlayers from "./exportPlayers.ts";
import exportStats from "./exportStats.ts";
import fantasyDraft from "./fantasyDraft.ts";
import freeAgents from "./freeAgents.ts";
import frivolitiesDraftClasses from "./frivolitiesDraftClasses.ts";
import frivolitiesDraftPosition from "./frivolitiesDraftPosition.ts";
import frivolitiesJerseyNumbers from "./frivolitiesJerseyNumbers.ts";
import frivolitiesTeamSeasons from "./frivolitiesTeamSeasons.ts";
import frivolitiesTrades from "./frivolitiesTrades.ts";
import gameLog from "./gameLog.ts";
import globalSettings from "./globalSettings.ts";
import gmHistory from "./gmHistory.ts";
import godMode from "./godMode.ts";
import hallOfFame from "./hallOfFame.ts";
import headToHead from "./headToHead.ts";
import headToHeadAll from "./headToHeadAll.ts";
import history from "./history.ts";
import historyAll from "./historyAll.ts";
import importPlayers from "./importPlayers.ts";
import importPlayersReal from "./importPlayersReal.ts";
import inbox from "./inbox.ts";
import injuries from "./injuries.ts";
import keyboardShortcuts from "./keyboardShortcuts.ts";
import leaders from "./leaders.ts";
import leadersProgressive from "./leadersProgressive.ts";
import leadersYears from "./leadersYears.ts";
import leagueDashboard from "./leagueDashboard.ts";
import leagueFinances from "./leagueFinances.ts";
import leagueStats from "./leagueStats.ts";
import liveGame from "./liveGame.ts";
import manageConfs from "./manageConfs.ts";
import manageTeams from "./manageTeams.ts";
import message from "./message.ts";
import most from "./most.ts";
import multiTeamMode from "./multiTeamMode.ts";
import negotiation from "./negotiation.ts";
import negotiationList from "./negotiationList.ts";
import newLeague from "./newLeague.ts";
import newTeam from "./newTeam.ts";
import news from "./news.ts";
import notes from "./notes.ts";
import player from "./player.ts";
import playerBios from "./playerBios.ts";
import playerFeats from "./playerFeats.ts";
import playerGameLog from "./playerGameLog.ts";
import playerRatingDists from "./playerRatingDists.ts";
import playerRatings from "./playerRatings.ts";
import playerStatDists from "./playerStatDists.ts";
import playerGraphs from "./playerGraphs.ts";
import playerStats from "./playerStats.ts";
import playoffs from "./playoffs.ts";
import powerRankings from "./powerRankings.ts";
import protectPlayers from "./protectPlayers.ts";
import relatives from "./relatives.ts";
import resetPassword from "./resetPassword.ts";
import roster from "./roster.ts";
import rosterContinuity from "./rosterContinuity.ts";
import savedTrades from "./savedTrades.ts";
import schedule from "./schedule.ts";
import scheduleEditor from "./scheduleEditor.ts";
import scheduledEvents from "./scheduledEvents.ts";
import seasonPreview from "./seasonPreview.ts";
import settings from "./settings.ts";
import standings from "./standings.ts";
import teamFinances from "./teamFinances.ts";
import teamGraphs from "./teamGraphs.ts";
import teamHistory from "./teamHistory.ts";
import teamRecords from "./teamRecords.ts";
import teamStatDists from "./teamStatDists.ts";
import teamStats from "./teamStats.ts";
import trade from "./trade.ts";
import tradeProposals from "./tradeProposals.ts";
import tradeSummary from "./tradeSummary.ts";
import tradingBlock from "./tradingBlock.ts";
import tragicDeaths from "./tragicDeaths.ts";
import transactions from "./transactions.ts";
import upcomingFreeAgents from "./upcomingFreeAgents.ts";
import watchList from "./watchList.ts";

export default {
	account,
	accountUpdateCard,
	achievements,
	advancedPlayerSearch,
	allStar,
	allStarDunk,
	allStarHistory,
	allStarTeams,
	allStarThree,
	autoExpand,
	autoRelocate,
	awardRaces,
	awardsRecords,
	colleges,
	comparePlayers,
	countries,
	customizePlayer,
	dailySchedule,
	dangerZone,
	dashboard,
	defaultNewLeagueSettings,
	depth,
	draft,
	draftHistory,
	draftLottery,
	draftPicks,
	draftScouting,
	draftTeamHistory,
	editAwards,
	exhibition,
	exhibitionGame,
	expansionDraft,
	exportLeague,
	exportPlayers,
	exportStats,
	fantasyDraft,
	freeAgents,
	frivolitiesDraftClasses,
	frivolitiesDraftPosition,
	frivolitiesJerseyNumbers,
	frivolitiesTeamSeasons,
	frivolitiesTrades,
	gameLog,
	globalSettings,
	gmHistory,
	godMode,
	hallOfFame,
	headToHead,
	headToHeadAll,
	history,
	historyAll,
	importPlayers,
	importPlayersReal,
	injuries,
	inbox,
	keyboardShortcuts,
	leaders,
	leadersProgressive,
	leadersYears,
	leagueDashboard,
	leagueFinances,
	leagueStats,
	liveGame,
	manageConfs,
	manageTeams,
	message,
	most,
	multiTeamMode,
	negotiation,
	negotiationList,
	newLeague,
	newTeam,
	news,
	notes,
	player,
	playerBios,
	playerFeats,
	playerGameLog,
	playerRatingDists,
	playerRatings,
	playerStatDists,
	playerStats,
	playerGraphs,
	playoffs,
	powerRankings,
	protectPlayers,
	relatives,
	resetPassword,
	roster,
	rosterContinuity,
	savedTrades,
	schedule,
	scheduleEditor,
	scheduledEvents,
	seasonPreview,
	settings,
	standings,
	teamFinances,
	teamGraphs,
	teamHistory,
	teamRecords,
	teamStatDists,
	teamStats,
	trade,
	tradeProposals,
	tradeSummary,
	tradingBlock,
	tragicDeaths,
	transactions,
	upcomingFreeAgents,
	watchList,
};
